module.exports = __webpack_public_path__ + "static/media/tooltip-diversity.49be1eb0.svg";